<template>
  <v-flex v-cloak class="post-block">
    <v-card>
      <v-layout
          class="activity-post"
          row
          wrap>
        <post-owner
            :actions="postActions"
            :can-edit-all-activity-feed="canEditAllActivityFeed"
            :is-admin-page-post="isAdminPageFeed"
            :post="activity"
            @handleHideReason="showReasonBox"></post-owner>
        <v-flex class="card-flex" xs12>
                    <span v-if="activity.title">
                        <span class="activity-post__title" v-html="activity.title"></span><br/><br/> </span>
          <span v-for="(message, i) in postMessage" :key="i">
                        <span v-if="!message.containsMention" class="activity-post__body">
                            <span v-if="message.isOpportunityNetworkLinkExists"
                                  :data-qe-id="`message_${i}_text`"
                                  @click="showConfirmationDialog"
                                  v-html="message.text">
                            </span>
                            <span v-else :data-qe-id="`message_${i}_text`" v-html="message.text">
                            </span>
                        </span>

                        <v-menu
                            v-else
                            :close-on-content-click="false"
                            :nudge-width="200"
                            :open-on-hover="true"
                            class="activity-post__body"
                            content-class="member-mention-pop"
                            offset-x>

                            <span slot="activator">
                                <span @click="unlickClick" v-html="message.text">
                                </span>
                            </span>

                            <v-card>
                                <v-list>
                                    <v-list-tile avatar>
                                        <v-list-tile-avatar v-if="message.mention">
                                            <img :onerror="imageErrorFallback(message.mention.fallbackProfileImageUrl)"
                                                 :src="message.mention.profileImageUrl">
                                        </v-list-tile-avatar>

                                        <v-list-tile-content v-if="message.mention">
                                            <v-list-tile-title>{{ message.mention.displayName }}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ message.mention.primaryChapter }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                                <v-flex v-if="message.mention" text-xs-center>
                                    <v-btn :href="'#/memberProfile?memberId=' + message.mention.personId"
                                           class="primary_btn transparent">View Profile</v-btn>
                                </v-flex>
                            </v-card>
                        </v-menu>
                    </span>
          <span v-if="isShowSeeMore">
                        <a id="btn_see_more" class="activity-post__seemore" data-qe-id="post_message_see_more_link"
                           @click="seeMorePostMessage()">
                            {{ appCommonConstants.SEE_MORE }}
                        </a>
                    </span>
        </v-flex>
        <v-layout row wrap>
          <v-flex v-if="activity.postImage && activity.postImage.length > 0" xs12>
            <post-photos :enlarge-photo-handler="setSelectedImageIndex" :photo-list="activity.postImage"></post-photos>
          </v-flex>
          <v-flex v-if="activity.postAttachment && activity.postAttachment.length > 0">
            <post-attachments :attachment-list="activity.postAttachment"></post-attachments>
          </v-flex>
        </v-layout>
        <v-flex class="activity-post__Likes" xs12>
          <v-flex v-if="!isAdminPageFeed && (activity.likeCount || activity.commentCount)">
            <v-divider></v-divider>
          </v-flex>
          <span class="activity-post__statement">
                        <em>
                            <span v-if="!isAdminPageFeed && activity.likeCount" class="activity-post__likesStatement"
                                  data-qe-id="post_show_liked_user_btn" @click="showLikedUsers()">
                                {{ likesForThePost }}
                            </span>
                        </em>
                        <em class="text-xs-right">
                            <span v-if="!isAdminPageFeed && activity.commentCount"
                                  class="activity-post__commentsStatement" data-qe-id="post_show_commented_user_btn"
                                  @click="showCommentedUsers()">
                                {{ commentForThePost }}
                            </span>
                        </em>
                    </span>
          <post-control
              :activity="activity"
              :can-like="canEditAllActivityFeed"
              :handle-comment="handleComment"
              :handle-like="handleLike"
              :is-admin-page-post-control="isAdminPageFeed">
          </post-control>
        </v-flex>
        <v-flex
            v-if="toggleComment"
            class="activity-post__comments"
            xs12>
          <add-comment
              v-if="activity.canComment && canEditAllActivityFeed && !isAdminPageFeed && !activity.featuredComments.length"
              :comment-count-value="activity.commentCount"
              :parent-id="activity.id">
          </add-comment>
          <comment-list
              v-if="activity.featuredComments.length"
              :can-comment="activity.canComment && canEditAllActivityFeed"
              :can-edit-all-activity-feed="canEditAllActivityFeed"
              :comment-count-value="activity.commentCount"
              :comment-list="activity.featuredComments"
              :inappropriate-children="activity.inappropriateChildren"
              :isAdminPageFeed="isAdminPageFeed"
              :parent-post-id="activity.id">
          </comment-list>
        </v-flex>
        <v-flex
            v-if="displayReasonBox"
            class="form-control reason-field"
            xs12>
          <label class="reason-field__label">{{ communityCommonConstant.post.REASON }}</label>
          <v-textarea
              v-model="reason"
              :placeholder="communityCommonConstant.post.HIDE_REASON"
              data-qe-id="post_hide_reason_text-area"
              maxlength="200">
          </v-textarea>
          <v-flex text-xs-right>
            <v-btn
                class="primary_btn transparent"
                data-qe-id="moderated_post_cancel_btn"
                flat
                @click="cancelHideModeratedPost()">
              {{ appCommonConstants.CANCEL }}
            </v-btn>
            <v-btn
                class="primary_btn"
                dark
                data-qe-id="moderated_post_save_btn"
                @click="confirmHideModeratedPost()">
              {{ appCommonConstants.SAVE }}
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog
        v-model="dialogState.dialogOpen"
        class="activity-post__dialog_box"
        width="400">
      <commented-users
          v-if="dialogState.dialogOpen"
          :comment-count="activity.commentCount"
          :dialog-state="dialogState"
          :post-id="activity.id"
          :user-has-commented="activity.userHasCommented"></commented-users>
    </v-dialog>
    <v-dialog
        v-model="expandPhoto.expandOpen"
        class="activity-post__dialog_box"
        width="1400">
      <expanded-image
          v-if="expandPhoto.expandOpen"
          :can-comment="activity.canComment"
          :can-edit-all-activity-feed="canEditAllActivityFeed"
          :expand-photo="expandPhoto"
          :expand-photo-obj="activity"
          :expanded-image-index="selectedImageIndex"></expanded-image>
    </v-dialog>
    <v-dialog
        v-model="likeDialogState.likeDialogOpen"
        class="activity-post__dialog_box"
        width="400">
      <liked-users
          v-if="likeDialogState.likeDialogOpen"
          :like-count="activity.likeCount"
          :like-dialog-state="likeDialogState"
          :post-id="activity.id"
          :user-has-liked="activity.userHasLiked"></liked-users>
    </v-dialog>
    <transaction-hub-dialog
        v-if="openConfirmationDialog"
        v-model="openConfirmationDialog">
    </transaction-hub-dialog>
  </v-flex>
</template>

<script>
import PostOwner from "../PostOwner/PostOwner";
import {
  communityCommonConstant,
  likeStatement,
  commentStatement,
  postActions,
  showTransactionHubPopup,
} from "../communityCommon.constant";
import PostControl from "./PostControl";
import CommentList from "../Comment/CommentList";
import AddPost from "../AddPost/AddPost";
import AddComment from "../AddComment/AddComment";
import { mapActions, mapGetters } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import CommentedUsers from "../CommentedUsers/CommentedUsers";
import LikedUsers from "../CommentedUsers/LikedUsers";
import ActivityImageGrid from "../ActivityImagesGrid/ActivityImagesGrid";
import ExpandedImage from "./ExpandedImage.vue";
import { appCommonConstants } from "../../appCommon.constants";
import PostPhotos from "./PostPhotos";
import PostAttachments from "../../ChapterPage/FileAttachment/PostAttachments";
import { imageErrorFallback, removeHTMLAndSpecialCharacters } from "../../../common/utils/utils";
import TransactionHubDialog from "../TransactionHub/TransactionHubDialog";
import { storeGetters } from "../../../store/storeGetters.constant";
import { trackActivityPostData } from "@/plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";

export default {
  name: "ActivityPost",
  components: {
    PostPhotos,
    AddComment,
    AddPost,
    CommentList,
    PostControl,
    PostOwner,
    CommentedUsers,
    LikedUsers,
    ActivityImageGrid,
    ExpandedImage,
    PostAttachments,
    TransactionHubDialog,
  },
  created() {
    this.postActivityMessage();
    this.toggleComment = this.activity && this.activity.featuredComments &&
    this.activity.featuredComments.length &&
    this.activity.hasOwnProperty('showAllCommentsAndReplies') ?
        this.activity.showAllCommentsAndReplies :
        false;
    this.openCommentSection();
  },
  mounted() {
    if (this.$route.query.commentId) {
      this.scrollToComment(this.$route.query.commentId);
    }
  },
  data: () => ({
    postMessage: [],
    communityCommonConstant,
    appCommonConstants,
    postActions,
    toggleComment: false,
    dialogState: {
      dialogOpen: false,
    },
    expandPhoto: {
      expandOpen: false,
    },
    likeDialogState: {
      likeDialogOpen: false,
    },
    isShowSeeMore: false,
    selectedImageIndex: null,
    displayReasonBox: false,
    reason: "",
    openConfirmationDialog: false,
  }),
  props: {
    activity: {
      type: Object,
      required: true,
    },
    canEditAllActivityFeed: {
      type: Boolean,
      required: true,
    },
    isAdminPageFeed: {
      type: Boolean,
      default: false,
    },
    moderationReason: {
      type: Object,
      required: false,
    },
  },
  methods: {
    ...mapActions({
      sendHidePostModeration: `chapter/${storeAction.sendHidePostModeration}`,
    }),
    imageErrorFallback,
    removeHTMLAndSpecialCharacters,
    openCommentSection() {
      this.toggleComment = this.$route && this.$route.query && this.$route.query.postId ? true : this.toggleComment;
    },
    scrollToComment(commentId) {
      const element = document.getElementById(commentId);
      const headerOffset = 70;
      if (element && element.getBoundingClientRect()) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    modifyArray(result) {
      let array = [];
      let count = 0;
      let arrayindex = -1;
      const dots = "...";
      result.forEach((element, index) => {
        element.index = index;
        if (element && count < 150) {
          element.length = removeHTMLAndSpecialCharacters(element.text).trim().length;
          count += element.length;
          if (count >= 150 && !element.containsMention) {
            arrayindex = index;
            this.isShowSeeMore = true;
            const buildString = removeHTMLAndSpecialCharacters(element.text);
            let finalString = buildString.trim().substring(0, 150) + dots;
            const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
            const containSpecialCharacter = format.test(finalString.split(" ").pop());
            if (containSpecialCharacter) {
              const lastItem = finalString.split(" ").pop();
              finalString = finalString.replace(lastItem, lastItem.replace(/[^a-zA-Z ]/g, ""));
            }
            element.text = finalString + dots;
          }
        }
      });
      if (arrayindex !== -1) {
        array = result.slice(0, arrayindex + 1);
        return array;
      }
      return result;
    },
    truncate(str, len) {
      return str.substring(0, (`${str} `).lastIndexOf(' ', len));
    },
    fixMentionSpacing(ckeditorData) {
      const userMentionPattern = /<a id="(.*?)"/g;
      let match = userMentionPattern.exec(ckeditorData);
      while (match != null) {
        if (ckeditorData.charAt(match.index - 1) === ' ') {
          ckeditorData = this.setCharAt(ckeditorData, match.index - 1, '&nbsp');
        }
        match = userMentionPattern.exec(ckeditorData);
      }

      const OldUserMentionPattern = /<a href="(.*?)"/g;
      let oldMatch = OldUserMentionPattern.exec(ckeditorData);

      while (oldMatch != null) {
        if (ckeditorData.charAt(oldMatch.index - 1) === ' ') {
          ckeditorData = this.setCharAt(ckeditorData, oldMatch.index - 1, '&nbsp');
        }
        oldMatch = OldUserMentionPattern.exec(ckeditorData);
      }
      return ckeditorData;
    },
    setCharAt(str, index, chr) {
      if (index > str.length - 1) return str;
      return str.substr(0, index) + chr + str.substr(index + 1);
    },
    iterate(showCompleteMessage) {
      const dots = "...";
      this.isShowSeeMore = false;
      if (this.activity.body) {
        this.activity.body = this.fixMentionSpacing(this.activity.body);
        let result = this.activityBodyMessageArray(this.activity.body.trim());
        if (result && result.length > 1 && !showCompleteMessage) {
          result.forEach((r) => {
            r.text = r.text.trim().replace(/<p>/g, '\n');
          });
          result = this.modifyArray(result);
        } else if (result && result.length === 1 && !showCompleteMessage) {
          const rawHtml = removeHTMLAndSpecialCharacters(result[0].text);
          const removedHTML = rawHtml.trim();
          if (removedHTML.length > 150) {
            this.isShowSeeMore = true;
            result[0].text = removedHTML.substring(0, 150) + dots;
          }
        } else if (result && result.length !== 0 && showCompleteMessage) {
          result.forEach((r) => {
            r.text = r.text.trim().replace(/<p>/g, '\n');
          });
        }
        return result;
      }
    },
    ...mapActions({
      sendLike: `chapter/${storeAction.sendLike}`,
      sendUnlike: `chapter/${storeAction.sendUnlike}`,
    }),
    handleLike() {
      if (this.activity.userHasLiked) {
        this.sendUnlike(this.activity.id);
        return true;
      }
      if (!this.activity.userHasLiked) {
        this.sendLike(this.activity.id);
        trackActivityPostData(gtmEventName.C_Post_Like, this.activity);
        return true;
      }
    },
    unlickClick(e) {
      e.preventDefault();
    },
    handleComment() {
      this.toggleComment = !this.toggleComment;
    },
    showCommentedUsers() {
      this.dialogState.dialogOpen = true;
    },
    ShowEnlargedPost() {
      this.expandPhoto.expandOpen = true;
    },
    showLikedUsers() {
      this.likeDialogState.likeDialogOpen = true;
    },
    showMemberMention() {
      this.isShowMention = true;
    },
    isMention(text) {
      let hasMention = false;
      const userMentionPattern = /<a id="(.*?)"/g;
      const OldUserMentionPattern = /<a href="(.*?)"/g;
      const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
      const matches = text.match(userMentionPattern);
      const oldMatches = text.match(OldUserMentionPattern);
      if (matches) {
        const string1 = matches[0].indexOf("=");
        const string2 = matches[0].length;
        const hrefValue = matches[0].substring(string1 + 2, string2 - 1);
        hasMention = guidPattern.test(hrefValue);
      } else if (oldMatches) {
        const string1 = oldMatches[0].indexOf("=");
        const string2 = oldMatches[0].length;
        const hrefValue = oldMatches[0].substring(string1 + 2, string2 - 1);
        hasMention = guidPattern.test(hrefValue);
      }
      return hasMention;
    },
    activityBodyMessageArray(str, strArr = []) {
      const i1 = str.indexOf("<a");
      const i2 = str.indexOf("</a>");

      if (i1 > 0) {
        if (this.isMention(str.substring(i1, i2 + 4))) {
          strArr.push(str.substring(0, i1));
          strArr.push(str.substring(i1, i2 + 4));
        } else if (strArr.length === 0 || this.isMention(strArr[strArr.length - 1])) {
          strArr.push(str.substring(0, i2 + 4));
        } else {
          strArr[strArr.length - 1] += str.substring(0, i2 + 4);
        }
        const res = str.substr(i2 + 4);
        if (res.length > 0) {
          return this.activityBodyMessageArray(res, strArr);
        }
      } else if (str && str.length > 0) {
        if (strArr.length === 0 || this.isMention(strArr[strArr.length - 1])) {
          strArr.push(str);
        } else {
          strArr[strArr.length - 1] += str;
        }
      }
      if (this.activity.mentions) {
        return strArr.map((text) => {
          const hasMention = this.isMention(text);
          const rx = /<a\s+(?:[^>]*?\s+)?id=(["'])(.*?)\1/;
          const oldRx = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/;
          const containsMention = text.includes('<a') && hasMention;
          const id1 = (text.match(rx) || [])[2];
          const id2 = (text.match(oldRx) || [])[2];
          const id = id1 || id2;
          return {
            text,
            containsMention,
            isOpportunityNetworkLinkExists: text && text.toLowerCase().includes(this.communityCommonConstant.transactionHub.OPPORTUNITY_DOMAIN),
            mention: this.activity.mentions.find((obj) => {
              return id && obj.personId.toLowerCase() === id.toLowerCase();
            }),
          };
        });
      }
      return [];
    },
    postActivityMessage() {
      this.postMessage = this.iterate(false);
    },
    seeMorePostMessage() {
      this.postMessage = this.iterate(true);
      this.isShowSeeMore = false;
    },
    setSelectedImageIndex(imageIndex) {
      this.selectedImageIndex = imageIndex;
      this.expandPhoto.expandOpen = true;
    },
    showReasonBox(val) {
      this.displayReasonBox = val;
    },
    confirmHideModeratedPost() {
      const moderationReason = {};
      moderationReason.postId = this.activity.id;
      moderationReason.Reason = this.reason.trim();
      this.sendHidePostModeration(moderationReason);
    },
    cancelHideModeratedPost() {
      this.showReasonBox(false);
    },
    showConfirmationDialog($event) {
      this.openConfirmationDialog = showTransactionHubPopup($event, this.isMobileAppBrowser);
    },
  },
  computed: {
    ...mapGetters({
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
    }),
    likesForThePost() {
      return likeStatement(this.activity);
    },
    commentForThePost() {
      return commentStatement(this.activity);
    },
  },
};
</script>

<style lang="scss">
@import "../../../common/styles/_colors.scss";
@import "../../../common/styles/_responsive.scss";

.new_post_image {
  object-fit: contain;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  max-height: 600px;
  display: table-cell;
  vertical-align: middle;
  position: relative;
}

.post_bckgrnd {
  background: $ypo-black-opac;
  padding: 5px;
  text-align: center;
  height: auto;
  max-height: 100%;
}

.post_details {
  background: $white;
  height: auto;
  max-height: 100%;
  overflow-y: auto;
  margin: 5px;
}

.layout_bcg {
  background: $ypo-black-opac;
  height: 100%;
  max-height: 100%;
  overflow: auto;
  width: 100%;
  max-width: 100%;
}

.card-flex {
  margin: 10px 10px 10px 25px;

  @media (max-width: 767px) {
    margin: 10px;
  }
}

.post-block {
  border-radius: 4px;
  background-color: $white;
  box-shadow: 0 1px 3px 0 rgba($black, 0.18);
  border: 1px solid rgba($ypo-gray, 0.4);
  margin-bottom: 15px;

  .v-card {
    box-shadow: none;

    &__text {
      padding: 0 2px;
    }
  }

  .reason-field {
    padding: 15px;

    &__label {
      font-size: 16px;
      color: $ypo-blue;
      font-weight: 600;
    }
  }

  @include breakpoint(xs) {
    box-shadow: none;
  }
}

.post_image {
  object-fit: contain;
  max-width: 100%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.activity-post {
  border-radius: 0;
  box-shadow: none;
  padding-top: 5px;

  &__title {
    color: $ypo-gray-text;
    font-size: 15px;
    letter-spacing: 0.1px;
    line-height: 24px;
    margin-top: 10px;
    font-weight: bold;
    text-align: left;
    position: relative;
  }

  &__body {
    color: $ypo-gray-text;
    font-size: 14px;
    line-height: 24px;
    word-break: break-word;

    img {
      max-width: 100%;
    }

    :focus {
      height: 40px;
      width: 200px;
    }

    @include breakpoint(sm) {
      padding-bottom: 5px;
    }
  }

  &__likes {
    color: $ypo-blue;
  }

  &__statement {
    color: $ypo-gray-text;
    font-size: 12px;
    letter-spacing: 0.36px;
    position: absolute;
    left: 0;
    top: -12px;
    padding: 0 20px;
    width: 100%;

    em {
      font-style: normal;
      display: inline-block;
      width: 50%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-right: 10px;

      span {
        cursor: pointer;
      }

      + em {
        padding-right: 0px;
      }
    }
  }

  &__comments {
    background: $ypo-extra-light-gray;

    .post {
      min-height: inherit;
      margin: 10px;

      &__Allow_Comments {
        padding: 10px;

        .v-btn {
          margin: 0;
        }
      }

      .v-avatar {
        left: 0;
        top: 0;
      }

      textarea {
        height: 50px;
        background: $white;
        border-radius: 4px;
        margin: 0 !important;
      }
    }

    .post-expand-block {
      background: $white;
      box-shadow: none;
    }
  }

  &__Likes {
    padding: 15px 20px 10px 20px;
    margin-top: 25px;
    position: relative;
  }

  &__dialog_box {
    width: 500px;
    min-height: 50%;
  }

  &__seemore {
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
}

.activity-post__seemore {
  a {
    color: $ypo-title-blue-gray;
    transition: 0.3s;

    &:hover {
      color: $ypo_blue;
    }
  }
}

.member-mention-pop {
  border-radius: 4px;
  background-color: $white;
  box-shadow: 0 8px 10px 1px rgba($black, 0.14),
  0 3px 14px 2px rgba($black, 0.12), 0 5px 5px -3px rgba($black, 0.2);
  width: 350px;

  .v-avatar {
    width: 50px !important;
    height: 50px !important;
    margin-right: 10px;
  }

  .v-list__tile__title {
    color: $ypo-cta;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.25px;
    line-height: 18px;
  }

  .v-list__tile__sub-title {
    color: $ypo-cta !important;
    font-size: 12px;
    letter-spacing: -0.1px;
    line-height: 20px;
  }

  .primary_btn {
    margin: 10px 5px 20px 5px;
    border: 1px solid $ypo_blue !important;
    border-radius: 4px;

    &:hover {
      background: $ypo_blue !important;
      color: $white !important;
    }
  }
}
</style>
